var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2198_24591)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.167969H20V10.7805H0V0.167969Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.5547H20V23.5005H0V10.5547Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00313 6.94063C14.1656 8.29375 10.8469 14.9281 6.775 12.1656L6.5 12.5906C8.89687 14.2969 11.2688 12.9219 11.9375 11.1406C12.6312 9.30312 11.7 6.71875 9.04375 6.45312L9.00313 6.94063Z",
    fill: "#FFEC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.17031 12.6461L7.84844 12.9617L7.52969 13.643L6.85156 13.3242L7.17031 12.6461ZM11.8266 9.53672H12.5766V10.2867H11.8266V9.53672ZM11.4609 8.32109L12.1578 8.05234L12.4297 8.74922L11.7328 9.02109L11.4609 8.32109ZM10.6484 7.41172L11.1828 6.88359L11.7109 7.41484L11.1797 7.94297L10.6484 7.41172ZM9.82969 6.16797L10.5297 6.43047L10.2641 7.13047L9.56406 6.86797L9.82969 6.16797ZM11.7328 10.7461L12.4297 11.0242L12.1484 11.718L11.4547 11.4398L11.7328 10.7461ZM9.54844 12.9336L10.2359 12.643L10.5328 13.3305L9.84531 13.6242L9.54844 12.9336ZM8.31406 13.0211H9.06406V13.7711H8.31406V13.0211ZM9.60469 9.39609L8.97031 8.92734L8.33594 9.38359L8.58594 8.66484L7.95156 8.19609H8.71719L8.98281 7.48984L9.22656 8.19922L9.99844 8.18984L9.38594 8.66797L9.60469 9.39922V9.39609Z",
    fill: "#FFEC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3559 13.1328C12.3184 13.1453 12.1621 13.5203 12.0527 13.7016L12.1684 13.7328C12.5934 13.8828 12.8059 14.0203 12.9871 14.2797C13.029 14.3205 13.0841 14.3451 13.1425 14.3491C13.2008 14.3531 13.2587 14.3363 13.3059 14.3016C13.3059 14.3016 13.3934 14.2703 13.5059 14.1453C13.5996 14.0047 13.5746 13.8953 13.4621 13.7984C13.1184 13.5484 12.7465 13.3609 12.3559 13.1328Z",
    fill: "#FFEE00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2727 13.9594C13.2727 13.9954 13.2583 14.03 13.2329 14.0555C13.2074 14.081 13.1728 14.0953 13.1367 14.0953C13.1007 14.0953 13.0661 14.081 13.0406 14.0555C13.0151 14.03 13.0008 13.9954 13.0008 13.9594C13.0008 13.9237 13.015 13.8895 13.0402 13.8643C13.0654 13.8391 13.0995 13.825 13.1352 13.825C13.1708 13.825 13.205 13.8391 13.2302 13.8643C13.2554 13.8895 13.2695 13.9237 13.2695 13.9594H13.2727ZM12.6039 13.5344C12.6039 13.5704 12.5896 13.605 12.5641 13.6305C12.5386 13.656 12.504 13.6703 12.468 13.6703C12.4319 13.6703 12.3974 13.656 12.3719 13.6305C12.3464 13.605 12.332 13.5704 12.332 13.5344C12.332 13.4983 12.3464 13.4637 12.3719 13.4382C12.3974 13.4128 12.4319 13.3984 12.468 13.3984C12.504 13.3984 12.5386 13.4128 12.5641 13.4382C12.5896 13.4637 12.6039 13.4983 12.6039 13.5344ZM12.9445 13.7531C12.9445 13.7892 12.9302 13.8237 12.9047 13.8492C12.8792 13.8747 12.8447 13.8891 12.8086 13.8891C12.7726 13.8891 12.738 13.8747 12.7125 13.8492C12.687 13.8237 12.6727 13.7892 12.6727 13.7531C12.6727 13.7171 12.687 13.6825 12.7125 13.657C12.738 13.6315 12.7726 13.6172 12.8086 13.6172C12.8447 13.6172 12.8792 13.6315 12.9047 13.657C12.9302 13.6825 12.9445 13.7171 12.9445 13.7531Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9977 13.6734C10.6664 12.9141 9.26955 12.0953 7.93517 11.3359C7.3508 10.9703 7.32267 10.2922 7.71642 9.77656C7.75392 9.70469 7.80392 9.72031 7.82267 9.76094C7.86955 10.0109 8.01017 10.2703 8.17892 10.4328C9.56397 11.304 10.936 12.1958 12.2945 13.1078C12.1883 13.2891 12.107 13.4922 11.9977 13.6703V13.6734Z",
    fill: "#FFEE00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1445 11.8555L11.7008 12.3555L11.2008 12.9117L10.6445 12.4117L11.1445 11.8555Z",
    fill: "#FFEC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2148 13.2109L8.30859 10.8516M11.7336 12.6672L10.418 11.8141M10.9867 13.1484L9.64609 12.3734",
    stroke: "black",
    strokeWidth: 0.375
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2198_24591"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAo);
export default __webpack_public_path__ + "static/media/AO.8699110b93805f8b8104a8ad49d5b747.svg";
export { ForwardRef as ReactComponent };